import { useDispatch } from "react-redux"
import axiosClient from "../../api/axios-client"
import { openModal } from 'Actions/ui'
import { notify } from 'Actions/notifications'
import { connect } from 'react-redux'
import { injectStripe } from 'react-stripe-elements'
import Button from 'Ui/Button'

const handleSubscribeToScan = async ({ dispatch, stripe, handleChangeOffer, interval, offerVersion, setIsLoading }) => {
  if (interval === 'month') return handleChangeOffer(stripe, { type: 'scan' })
  
  setIsLoading(true)

  try {
    const res = await axiosClient.get('/api/user/subscribe-to-expedition-or-scan-prorate')
    setIsLoading(false)

    console.log('res --------------------------------->')
    console.log(res)
    const proration = res.data.reduce((acc, item) => acc + item.amount, 0) / 100

    dispatch(
      openModal('confirmPaymentScan', {
        onValidate: () => handleChangeOffer(stripe, { type: 'scan' }),
        proration,
        offerVersion,
      }),
    )
  } catch (e) {
    setIsLoading(false)
    console.log('e ------------------------------------------>')
    console.log(e)
    dispatch(
      notify(
        'error',
        'Une erreur est survenue lors de la récupération des détails de votre abonnement.',
      ),
    )
  }
}

const SubscribeScanForm = ({
  handleChangeOffer,
  stripe,
  buttonText,
  interval,
  offerVersion,
  isLoading,
  setIsLoading,
}) => {
  const dispatch = useDispatch()

  return (
    <Button
      disabled={isLoading}
      label={
        isLoading ? (
          <div className="flex justify-center align-center">
            <img height="15px" src="/assets/images/spinner.gif" alt="Veuillez patienter" />
          </div>
        ) : (
          buttonText || 'Souscrire'
        )
      }
      onClick={() => handleSubscribeToScan({ dispatch, stripe, handleChangeOffer, interval, offerVersion, setIsLoading })}
      secondaryClass="primary small-height"
    />
  )
}


export default connect()(injectStripe(SubscribeScanForm))